import { useMemo } from "react";

export const SentimentBar = ({ percentage }: { percentage: number }) => {
  const validPercentage = useMemo(() => {
    if (percentage < 0) return 0;
    if (percentage > 100) return 100;
    return percentage;
  }, [percentage]);
  return (
    <div className="flex flex-col gap-2">
      <div className="relative rounded-[4px] h-[6px] w-[100%] bg-gradient-to-r from-[#F44336] via-[#FFCA28] to-[#4CAF50]">
        <div
          style={{ left: `${validPercentage}%` }}
          className="absolute -translate-x-1/2 -translate-y-1/4 w-[12px] h-[12px] rounded-[50%] bg-[#007DFF]"
        />
      </div>
      <div className="flex justify-between items-center">
        <span className="font-ibm-plex-sans text-[12px] font-normal leading-[16px]">
          Sell
        </span>
        <span className="font-ibm-plex-sans text-[12px] font-normal leading-[16px]">
          Neutral
        </span>
        <span className="font-ibm-plex-sans text-[12px] font-normal leading-[16px]">
          Buy
        </span>
      </div>
    </div>
  );
};
